<template>
<div class="card position-relative overflow-auto">
	<div class="dash-card-header"> 
		<div class="back-link ml-3">
			<!-- <button @click="hasHistory() ? $router.go(-1) : $router.push('/dashboard')">
				<img class="pull-left" src="@/assets/back.svg" >	
			</button> -->
		</div>

		<div class="title-div font-medium font-size-15 "><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t("Assessment")}}</div>
	</div>
	<div class="col-sm-12 p-16 f-16 assessment-text">
		 <h2 v-html="$t('ylswltkw')"></h2>
	</div>
	<div class=" mt-20 text-center">
		<button class="btn bg-color-grblue" @click="gotoAssessment"> {{ $t("Take the Assessment")}}</button>
	</div>
</div>
</template>

<script>

export default {
	name: "Assessment",
	data() {
		return {
			key: {}
		}
    },
	async mounted() {
		let res = await this.$store.dispatch('checkAuth', localStorage.getItem('user'))

		if(res.success && res.user) {
			await this.$router.push({ name: 'dashboard', params: {lang: localStorage.getItem('locale')} });
		}
	
	},
    methods: {
		hasHistory () { return window.history.length > 2 },	
		async gotoAssessment() {
			let user = JSON.parse(localStorage.getItem('user'))
			let url = process.env.VUE_APP_TWEGOS_ASSESSMENT + localStorage.getItem('locale') +  "/fitme/s/" + user.ukey;
 			window.location.href = url
		}
    }
}

</script>

<style scoped>

</style>